module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block block-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "block-content p-0"
  }, [_c('table', {
    staticClass: "table table-borderless table-striped table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.sales_channel_commissions), function(sales_channel_commission) {
    return _c('tr', {
      key: sales_channel_commission.id
    }, [_c('td', [_c('a', [_vm._v(_vm._s(sales_channel_commission.sales_channel_name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "row"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.commission_percentages[sales_channel_commission.id]),
        expression: "commission_percentages[sales_channel_commission.id]"
      }],
      ref: "input",
      refInFor: true,
      staticClass: "form-control",
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (_vm.commission_percentages[sales_channel_commission.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.commission_percentages, sales_channel_commission.id, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-noborder",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.updateSalesChannelCommissionField(sales_channel_commission.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check"
    })])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header block-header-default"
  }, [_c('h3', {
    staticClass: "block-title"
  }, [_vm._v("Commissies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Verkoopkanaal")]), _vm._v(" "), _c('th', [_vm._v("Commisiepercentage")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30896a70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/settings/CommissionTab.vue
// module id = 702
// module chunks = 1